import { render, staticRenderFns } from "./commissionSetLevel2.vue?vue&type=template&id=ec53d8ba&scoped=true"
import script from "./commissionSetLevel2.vue?vue&type=script&lang=js"
export * from "./commissionSetLevel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec53d8ba",
  null
  
)

export default component.exports